import { render } from "./Select2.vue?vue&type=template&id=e9d7c790"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Alex_from_officePC\\2024\\bugs\\GIZ-466_matrix\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__